"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var ElementParser = /** @class */ (function () {
    function ElementParser(cfg) {
        _.assign(this, cfg);
        this.init();
    }
    ElementParser.prototype.init = function () {
        this.config = {
            type: this.type,
            position: {
                fields: this.positionFields,
            },
            widthRatio: {
                // 宽度所占的分类的比例
                column: this.widthRatio || 3 / 5,
                rose: 0.9999999,
                multiplePie: 1 / 1.3,
            },
        };
    };
    return ElementParser;
}());
exports.default = ElementParser;
//# sourceMappingURL=base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/geoms/base.js
// module id = 311
// module chunks = 37